// reducers/formReducer.js
import { formPages } from "../../constants";
import {
  UPDATE_FORM_DATA,
  SET_CURRENT_STEP,
  RESET_FORM_DATA,
} from "../actions/formActions";
const initialState = {
  compensate: {},
  // currentStep: formPages.NewClaimantDetails, // Initial state should be set correctly
  currentStep: formPages.IntroCheckDetails, // Start with customer lookup
};



const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FORM_DATA:
      const updatedState = {
        ...state,
        compensate: { ...state.compensate, ...action.data },
      };

      // console.log("=== REDUX STATE UPDATE ===");
      // console.log("Action Type:", action.type);
      // console.log("Previous State:", state);
      // console.log("Action Data:", action.data);
      // console.log("New State:", updatedState);
      // console.log("===========================");

      return updatedState;


    case SET_CURRENT_STEP:
      const stepUpdatedState = {
        ...state,
        currentStep: action.data,
      };

      // console.log("=== STEP CHANGE ===");
      // console.log("Action Type:", action.type);
      // console.log("Previous Step:", state.currentStep);
      // console.log("New Step:", action.data);
      // console.log("===================");
      return stepUpdatedState;

    case RESET_FORM_DATA:
      return { ...initialState };


    default:
      return state;
  }
};

export default formReducer;
